export default __webpack_public_path__ + "static/media/block.2ea07738.svg";